import * as React from "react"
import { PageProps, Link, graphql } from "gatsby"

import Blog from "../components/blog"
import Seo from "../components/seo"
import { StaticImage } from "gatsby-plugin-image"

type DataProps = {
  site: {
    buildTime: string
  }
}

const Mesinkasirrestoran: React.FC<PageProps<DataProps>> = ({ data, path }) => (
  <Blog>
    <Seo title="Mesin Kasir Restoran" />
    <h1><strong><a href="/mesinkasirrestoran/">Mesin Kasir Resto</a></strong></h1>
<img className="img-fluid" alt="Mesin Kasir Restoran cafe rumah makan" src="/img/mesinkasironlineapp2.jpg"/>
    <p>
Solusi terbaik bagi pengusaha kuliner khusus nya dalam kebutuhan untuk dukungan penuh bekerja untuk transaksi kasir dengan modern technology, inventori stok management, proses pengubahan resep makanan dan minuman untuk menjadi sebuah menu siap saji, proses penjualan dengan touchscreen metode dengan gambar menu makanan minuman, system fastfood penjualan kasir langsung , system meja , semua tersedia secara full pada <a href="/mesinkasirrestoran/">mesin kasir restoran</a> ini. Metode full touchscreen semakin lebih baik dalam bekerja integrasi dengan kebutuhan waiters order dan mengirimkan pesanan ke kitchen hingga kebutuhan untuk kasir mencetak bill maupun bertransaksi dengan cepat, plus admin cek laporan pembukuan details.
    </p>
<p>Pelajari bagaimana device hardware ini bekerja dengan sempurna untuk point of sale pos kasir dan pembukuan.</p>

<div className="col-md-12 p-3 p-md-5">
<ul className="nav nav-pills mb-3" id="pills-tab">
  <li className="nav-item p-1" role="presentation">
    <button className="btn btn-dark btn-sm active" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true">Intro</button>
  </li>
  <li className="nav-item p-1" role="presentation">
    <button className="btn btn-dark btn-sm" id="pills-demokasir-tab" data-bs-toggle="pill" data-bs-target="#pills-demokasir" type="button" role="tab" aria-controls="pills-demokasir" aria-selected="false">Demo</button>
  </li>
  <li className="nav-item p-1" role="presentation">
    <button className="btn btn-dark btn-sm" id="pills-online-tab" data-bs-toggle="pill" data-bs-target="#pills-online" type="button" role="tab" aria-controls="pills-online" aria-selected="false">Online</button>
  </li>
  <li className="nav-item p-1" role="presentation">
    <button className="btn btn-dark btn-sm" id="pills-barcode-tab" data-bs-toggle="pill" data-bs-target="#pills-barcode" type="button" role="tab" aria-controls="pills-barcode" aria-selected="false">Cloud</button>
  </li>
</ul>
<div className="tab-content" id="pills-tabContent">
  <div className="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
   <p>Dukungan technology penuh dari ASUS untuk all in one touchscreen tersemat, slim desain fashionable super mewah dengan harga terjangkau untuk anda, bersama pos device terminal ini maka sensasi elegan luxury untuk display kasir pos menambah wibawa usaha bisnis, dukungan multiport menyempurnakan nya bekerja dengan berbagai peralatan kasir dan tentunya sudah termasuk installasi setting sehingga <a href="/mesinkasirrestoran/">mesin kasir restoran</a> siap digunakan di tempat anda.</p>
   <p>Penggunaan dengan skema dan konsep single standalone mesin kasir dalam bekerja untuk kebutuhan all in one hanya dengan satu mesin kasir restoran, serta kemampuan nya digunakan dalam kebutuhan pembagian divisi untuk kebutuhan system table meja misal nya, dengan waiters tablet order mencatat meja dan pesanan pelanggan , selanjutnya meneruskan pesanan ke bagian kitchen via printer maupun via printer display, kemudian memudahkan kasir dalam cetak bill dan struk kasir pelanggan dengan hanya 
   memilih meja yang di tempati oleh pelanggan maka secara otomatis nantinya semua menu akan tampil pada display kasir, dan kasir tingal melakukan tranasksi pembayaran pelanggan, kemudian rangkuman laporan laporan detail termasuk kebutuhan persediaan stok, laba rugi , penjualan, cash flow arus keuangan dan lain sebagai nya.</p>
   <p>
   Penggunaan metode dan teknologi offline desktop untuk bekerja secara offline system, dengan kemampuan secara penuh untuk digunakan single mesin kasir maupun dengan pembagian divisi shared via lan kabel dan wifi, 
   selanjutnya kebutuhan dalam bekerja dengan cloud mode web app untuk kebutuhan dalam bekerja dengan online metode untuk kebutuhan terbaik dalam digunakan untuk mobilitas penuh, baik cloud database maupun menggunakan full web app dalam bekerja, dengan full web app memudahkan dalam hal akses untuk setiap user sesuai dengan jabatan divisi masing masing dengan proteksi password login, 
   web app version full menyediakan kemudahan akses dari berbagai perangkat mulai dari mesin kasir pos point of sale, tablet order dan mobile waiters, baik via desktop , hingga smartphone android ios windows linux untuk diterapkan.
   </p>
  </div>
  <div className="tab-pane fade" id="pills-demokasir" role="tabpanel" aria-labelledby="pills-demokasir-tab">
  <div className="ratio ratio-16x9">
  <iframe width="560" height="315" className="rounded" src="https://www.youtube.com/embed/gGZcHO32mh4" title="mesin kasir restoran"></iframe>
</div>
  </div>
  <div className="tab-pane fade" id="pills-online" role="tabpanel" aria-labelledby="pills-online-tab">
  <div className="ratio ratio-16x9">
  <iframe width="560" height="315" className="rounded" src="https://www.youtube.com/embed/DtJO_2ZO8lE" title="mesin kasir online restoran cafe rumah makan"></iframe>
</div>
  </div>
  <div className="tab-pane fade" id="pills-barcode" role="tabpanel" aria-labelledby="pills-barcode-tab">
  <div className="ratio ratio-16x9">
  <iframe width="560" height="315" className="rounded" src="https://www.youtube.com/embed/BidBDJmKo0Y" title="mesin kasir toko resto"></iframe>
</div>
</div>
  </div>
</div>

 <p>Mulai pilih <a href="/mesinkasirrestoran/">mesin kasir restoran</a> mu sekarang dan mulai upgrade technology bersama kami.</p>
<div className="row">
    <div className="p-3 p-md-5 col-12 col-md-4">
<StaticImage
src="../img/TOUCHSCREEN2.webp"
className="img-fluid mt-3 mb-3"
loading="eager" 
id="start"
width={500}
quality={95}
formats={["auto", "webp", "avif", "svg"]}
alt="mesin kasir toko minimarket shop"
/>
<p>
    Version 2<br/>
 All in one touchscreen pos + printer kasir auto cutter + program software resto cafe.</p>
 <small>Rp.10.062.400</small><br/>
<a href="https://wa.me/6285646104747?text=Admin%20saya%20mau%20order%20Mesin%20Kasir%0ANama/Usaha%20%3A%0AAlamat%20%3A%0APaket%20Versi%20%3A%20Dua%0APrice%20%3A%20Rp.10.062.400%0APembayaran%20via%20%3A%0ABCA%200181884109 %20Suci%20Chanifah%0A%0Atolong%20diproses%20pesanan%20saya" className="button col-12">Buy Now</a>
    </div>
    <div className="p-3 p-md-5 col-12 col-md-4">
<StaticImage
src="../img/TOUCHSCREEN3.webp"
className="img-fluid mt-3 mb-3"
loading="eager" 
id="start"
width={500}
quality={95}
formats={["auto", "webp", "avif", "svg"]}
alt="mesin kasir toko minimarket shop"
/>
<p>
    Version 3<br/>
 All in one touchscreen pos + printer kasir auto cutter + cash drawer laci kasir + program software resto cafe.</p>
 <small>Rp.11.046.800</small><br/>
<a href="https://wa.me/6285646104747?text=Admin%20saya%20mau%20order%20Mesin%20Kasir%0ANama/Usaha%20%3A%0AAlamat%20%3A%0APaket%20Versi%20%3A%20Tiga%0APrice%20%3A%20Rp.11.046.800%0APembayaran%20via%20%3A%0ABCA%200181884109 %20Suci%20Chanifah%0A%0Atolong%20diproses%20pesanan%20saya" className="button col-12">Buy Now</a>
    </div>
    <div className="p-3 p-md-5 col-12 col-md-4">
<StaticImage
src="../img/TOUCHSCREEN4.webp"
className="img-fluid mt-3 mb-3"
loading="eager" 
id="start"
width={500}
quality={95}
formats={["auto", "webp", "avif", "svg"]}
alt="mesin kasir toko minimarket shop"
/>
<p>
    Version 4<br/>
 All in one touchscreen pos + printer kasir auto cutter + cash drawer laci kasir + laser barcode manual + program software resto cafe.</p>
 <small>Rp.12.032.600</small><br/>
<a href="https://wa.me/6285646104747?text=Admin%20saya%20mau%20order%20Mesin%20Kasir%0ANama/Usaha%20%3A%0AAlamat%20%3A%0APaket%20Versi%20%3A%20Empat%0APrice%20%3A%20Rp.12.032.600%0APembayaran%20via%20%3A%0ABCA%200181884109 %20Suci%20Chanifah%0A%0Atolong%20diproses%20pesanan%20saya" className="button col-12">Buy Now</a>
    </div>
    <div className="p-3 p-md-5 col-12 col-md-6">
<StaticImage
src="../img/TOUCHSCREEN5.webp"
className="img-fluid mt-3 mb-3"
loading="eager" 
id="start"
width={500}
quality={95}
formats={["auto", "webp", "avif", "svg"]}
alt="mesin kasir toko minimarket shop"
/>
<p>
    Version 5<br/>
    All in one touchscreen pos + printer kasir auto cutter + cash drawer laci kasir + laser barcode auto multi laser + program software resto cafe.</p>
    <small>Rp.14.547.800</small><br/>
<a href="https://wa.me/6285646104747?text=Admin%20saya%20mau%20order%20Mesin%20Kasir%0ANama/Usaha%20%3A%0AAlamat%20%3A%0APaket%20Versi%20%3A%20Lima%0APrice%20%3A%20Rp.14.547.800%0APembayaran%20via%20%3A%0ABCA%200181884109 %20Suci%20Chanifah%0A%0Atolong%20diproses%20pesanan%20saya" className="button col-12">Buy Now</a>
    </div>
    <div className="p-3 p-md-5 col-12 col-md-6">
<StaticImage
src="../img/TOUCHSCREEN6.webp"
className="img-fluid mt-3 mb-3"
loading="eager" 
id="start"
width={500}
quality={95}
formats={["auto", "webp", "avif", "svg"]}
alt="mesin kasir toko minimarket shop"
/>
<p>
    Version 6<br/>
    All in one touchscreen pos + printer kasir auto cutter + cash drawer laci kasir + laser barcode auto multi laser + mesin cetak barcode + program software resto cafe.</p>
    <small>Rp.18.534.200</small><br/>
<a href="https://wa.me/6285646104747?text=Admin%20saya%20mau%20order%20Mesin%20Kasir%0ANama/Usaha%20%3A%0AAlamat%20%3A%0APaket%20Versi%20%3A%20Enam%0APrice%20%3A%20Rp.18.534.200%0APembayaran%20via%20%3A%0ABCA%200181884109 %20Suci%20Chanifah%0A%0Atolong%20diproses%20pesanan%20saya" className="button col-12">Buy Now</a>
    </div>
    

    </div>
    <Link to="/">Go back to the homepage</Link>
  </Blog>
)

export default Mesinkasirrestoran

export const query = graphql`
  {
    site {
      buildTime(formatString: "YYYY-MM-DD hh:mm a z")
    }
  }
`
